import React from 'react';
import Button from '@material-ui/core/Button';
import cn from 'classnames';
import stylesParent from '../frame.module.scss';
import PropTypes from 'prop-types';
import Tooltip from '../../../../components/tooltip';

const FooterBlock = ({
  nextButtonClick,
  percentInOMText,
  estimatedDailyRewardText,
  isDisabled,
}) => {
  return (
    <>
      {percentInOMText || estimatedDailyRewardText ? (
        <div className={stylesParent.tooltipsContainer}>
          {percentInOMText ? (
            <div className={stylesParent.tooltipItem}>
              <Tooltip
                label='Estimated APR:'
                text={
                  <div className={stylesParent.tooltipText}>
                    Annual Percentage Reward (APR) refers to the annual percentage rate at which
                    your Staking assets earn Rewards on a yearly basis.
                    <br />
                    Click to learn more
                  </div>
                }
                value={percentInOMText}
              />
            </div>
          ) : null}
          {estimatedDailyRewardText ? (
            <div className={stylesParent.tooltipItem}>
              <Tooltip
                label={
                  <>
                    Estimated
                    <br />
                    Daily Rewards:
                  </>
                }
                value={estimatedDailyRewardText}
              />
            </div>
          ) : null}
        </div>
      ) : null}
      <div className={cn(stylesParent.cardFooterControls)}>
        <Button
          onClick={nextButtonClick}
          variant='contained'
          color='secondary'
          className={cn(stylesParent.cardFooterControlsButton, {
            [stylesParent.disabled]: isDisabled,
          })}
          disabled={isDisabled}
        >
          Next
        </Button>
      </div>
    </>
  );
};

FooterBlock.propTypes = {
  nextButtonClick: PropTypes.func.isRequired,
  percentInOMText: PropTypes.string,
  estimatedDailyRewardText: PropTypes.string,
  isDisabled: PropTypes.bool,
};

FooterBlock.defaultProps = {
  isDisabled: false,
};

export default FooterBlock;
